import { request } from "/src/utils/index.js";

export function Search(params) {
  // console.log(parmas);
  return request.get("sys/menu/list", { params });
}

export function Detail(params) {
  // console.log(parmas);
  return request.get("sys/menu" + params);
}

export function Add(params) {
  return request.post("sys/menu", params);
}

export function Update(params) {
  return request.put("sys/menu", params);
}

export function Delete(data) {
  return request.delete("sys/menu", { data });
}

